// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
});

export function button14_mouseIn(event) {
	//Add your code for this event here: 
	$w("#button13").show()
}

export function button14_mouseOut(event) {
	//Add your code for this event here: 
	$w("#button13").hide()
}

export function button16_mouseIn(event) {
	//Add your code for this event here: 
	$w("#button15").show()
}

export function button16_mouseOut(event) {
	//Add your code for this event here: 
	$w("#button15").hide()
}

export function button17_mouseIn(event) {
	//Add your code for this event here: 
	$w("#button18").show()
}

export function button17_mouseOut(event) {
	//Add your code for this event here: 
	$w("#button18").hide()
}

